//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'collect',
  components: {
  },
  data () {
    return {
      id:0,
      order_no:'',
      order:{
        factory:[],
        goods_num:0
      },
      num:0,
      submitStatus:false,
      pop:false,
      inputCode:'',
    }
  },
  created(){
     this.sign();
    // setTimeout(()=>{
    //   this.scanQRCode();
    // },300) 
  },
  mounted(){
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  methods:{
    scanQRCode(){
      let that = this;
      wx.ready(()=> {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode","barCode"],
          success: function (res) {
            setTimeout(()=>{
              // if(that.id <= 0){
                // that.$func.showToast(11);
                if(res.resultStr.indexOf(",") != -1){
                  that.order_no = res.resultStr.split(',')[1];
                }else{
                  that.order_no = res.resultStr;
                }
                that.getOrder();
              // }else{
              //   // that.$func.showToast(22);
              //   let code = res.resultStr.split(',')[1];
              //   // that.$func.showToast(code);
              //   that.factoryHouse(code,1);
              // }
            },1000);
          }
        })
      });
      wx.error((res)=> {
        console.log(res)
        // alert(res.errMsg);
      })
    },  
    sign(){
      let url = (window.location.href).split('#');
      if(url[0].indexOf('?') != '-1'){
        url = url[0].split('?');
      }
      this.$api.wxSign({url:url[0]}).then((res)=>{
        wx.config({
            debug: res.data.debug, // 开启调试模式,
            appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature,// 必填，签名，见附录1
            jsApiList: res.data.jsApiList || ['scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      });
    },

    getOrder(){
      this.order = {};
      this.submitStatus = false;
      if(!this.order_no || this.order_no.length != 23){
        this.$func.showToast('订单号无效');
        return ;
      }
      this.$api.getOrder({order_no:this.order_no}).then((res)=>{
        if(res){
          this.id = res.data.id;
          this.num = res.data.num;
          this.order = res.data;
          this.submitStatus = true;

          // if(this.num >= this.order.goods_num){
          //   this.submitStatus = true;
          // }
        }
      })  
    },
    factoryHouse(code,status){
      let that = this;
      if(isNaN(code)){
        that.$func.showToast('子订单码无效');
        return ;
      }
      if(code.length != 12){
        that.$func.showToast('子订单码无效');
        return ;
      }
      this.$api.factoryHouse({id:this.id,code:code,status:status}).then((res)=>{
        if(res){
          this.pop = false;
           that.order.factory.forEach((item,index)=>{
            if(item.factory_wash_code == code){
              if(item.status == 0){
                item.status = 1;
                if(that.num < that.order.goods_num){
                  that.num = Number(that.num) + 1;
                  if(that.num == that.order.goods_num){
                    that.submitStatus = true;
                  }
                }else{
                  that.submitStatus = true;
                }
                that.$forceUpdate();
              }
              return ;
            }
          });
        }
      })  
    },
    changePop(){
      this.pop = !this.pop;
    },
    eventInputCode(){
      this.factoryHouse(this.inputCode,2);
    },
    submit(){
      if(!this.submitStatus){
        return false;
      }
      if (!this.id) {
          this.$func.showToast('订单号不存在，请扫码');
          return false;
      }
      this.$api.wareHouse({id:this.id}).then((res)=>{
        if(res){
          this.$func.showToast('入库成功');
          // wx.ready(function () {
          //     let media = document.getElementById("musicBox");
          //     media.src = "https://wash.uunbiot.com/uploads/default/shouyicheggong.mp3"
          //     media.play();
          // });
          setTimeout(()=>{
            this.id = 0;
            this.order_no = '';
            this.num = 0;
            this.submitStatus = false;
          },300)
        }
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/wareHouse.vue